module.exports = __webpack_public_path__ + "img/serve.96ef444e.png";